export default "/images/vendor/flag-icon-css/flags/4x3/ck.svg?65a80cb3a138985c22dcde8234f36142";